<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container id="bk" style="background-image: url('img/pso2_wallpaper2.jpg');" class="fill-height" fluid>
    <alertBar/>
    <v-alert v-model="alertMessage.status" :type="alertMessage.type">
      {{alertMessage.text}}
    </v-alert>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card elevation="12">
          <v-img class="white--text align-end" src="https://www.wallpaperup.com/uploads/wallpapers/2017/10/14/1108085/59fd98bf31c0b8077807a5ee31084ebb-700.jpg"/>
          <v-toolbar color="primary" dark flat>
            <v-avatar left>
              <v-img src="img/icons/arks_logo.png"></v-img>
            </v-avatar>
            <v-toolbar-title>PSO2-Keeper</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <v-form>
              <v-text-field v-model="loginCard.key" outlined id="password" label="Group Key" name="password" prepend-inner-icon="fas fa-key" type="password"/>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer />
            <v-btn color="grey" outlined @click="loginCard.key = ''">Clear</v-btn>
            <v-btn color="primary" outlined @click="login">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import alertBar from '../../bar/alertBar/alertBar.vue'
const firebase = require('firebase')
const database = firebase.database()
export default {
  name: 'loginCard',
  data: () => ({
    alertMessage: {
      status: false,
      text: '',
      type: 'info'
    },
    loginCard: {}
  }),
  components: {
    alertBar
  },
  created () {
    this.loginCard = this.$store.state.loginCard
    database.ref('/alertMessage').once('value', e => {
      let data = e.val()
      if (data.status) {
        this.alertMessage.status = true
        this.alertMessage.text = data.message
        this.alertMessage.type = data.type
      }
    })
  },
  methods: {
    login () {
      if (this.loginCard.key !== '') {
        database.ref('/game_record/' + this.loginCard.key).once('value', e => {
          if (e.val() != null) {
            this.$store.commit('setMission', {
              groupKey: this.loginCard.key,
              permissionToken: e.val().permission_toekn,
              name: e.val().name,
              quota: e.val().quota,
              img: e.val().img,
              players: e.val().players != null ? e.val().players.filter(item => item.name !== undefined) : []
            })
            this.$store.commit('setLoginState', true)
            database.ref('/game_record/' + this.loginCard.key).on('value', e2 => {
              let players = e2.val().players != null ? e2.val().players.filter(item => item.name !== undefined) : []
              this.$store.commit('setMission', {
                groupKey: this.loginCard.key,
                permissionToken: e.val().permission_toekn,
                name: e2.val().name,
                quota: e2.val().quota,
                img: e2.val().img,
                players: players
              })
              database.ref('/color').once('value', e => {
                let result = {
                  list: [],
                  unform: [],
                  group_player: {}
                }
                e.val().forEach((c, index) => {
                  if (index < this.$store.state.joinCard.quota / 4) {
                    result.list.push({ name: 'Team' + (index + 1), color: c })
                    result.group_player['Team' + (index + 1)] = this.$store.state.joinCard.players.filter(player => player.color === c && player != null)
                    result.unform = this.$store.state.joinCard.players.filter(player => player.color === '' && player != null)
                    if (result.group_player['Team' + (index + 1)].length === 0) {
                      result.group_player['Team' + (index + 1)] = [{
                        avatar: 'https://s1.zerochan.net/Matoi.%28PSO2%29.600.2266422.jpg',
                        class: 'GM',
                        leader: true,
                        name: 'Not Assign'
                      }]
                    }
                  }
                })
                this.$store.commit('setGroupCardState', result)
              })
            })
          } else {
            this.$store.commit('setSnackBar', {
              icon: 'fas fa-exclamation-circle',
              color: 'red',
              status: true,
              text: 'Your key is not exist',
              timeout: 2000
            })
          }
        })
      }
    }
  }
}
</script>

<style scoped>
  #bk {
    background-repeat: no-repeat;
    background-size: cover;
  }
</style>
